"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserInformationStep = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const organisms_1 = require("../../../components/organisms");
const Breakpoints_1 = require("../../../helper/Breakpoints");
const GlobalStyles_1 = require("../../../helper/GlobalStyles");
const atome_1 = require("../../../components/atome");
const Dashboard_web_style_1 = require("./Dashboard.web.style");
const UserInformationStep = (props) => {
    const { userInformation, monthNames, navigateTo } = props;
    return (react_1.default.createElement(organisms_1.TimelineEntry, { checked: true, title: !Breakpoints_1.isMobileOrTablet
            ? 'Angaben vervollständigen'
            : 'Angaben' + '\n' + 'vervollständigen', subTitle: !Breakpoints_1.isMobileOrTablet
            ? userInformation.progress.dataConfirmAt
                ? new Date(userInformation.progress.dataConfirmAt)
                    .getDate()
                    .toLocaleString('de-DE', {
                    minimumIntegerDigits: 2,
                }) +
                    '. ' +
                    monthNames[new Date(userInformation.progress.dataConfirmAt).getMonth()]
                : ' '
            : '', infoText: !Breakpoints_1.isMobileOrTablet ? (react_1.default.createElement(react_1.default.Fragment, null,
            "Sie haben Ihre Angaben vervollst\u00E4ndigt",
            !userInformation?.isAlreadyCannabisPatient && (react_1.default.createElement(react_1.default.Fragment, null, " und diese wurden erfolgreich gepr\u00FCft")),
            ".",
            react_1.default.createElement(react_native_1.View, { style: !Breakpoints_1.isMobileOrTablet ? null : GlobalStyles_1.globalStyles.marginTop25 },
                react_1.default.createElement(react_native_1.TouchableOpacity, { style: [
                        Dashboard_web_style_1.styles.button,
                        Dashboard_web_style_1.styles.buttonInfo,
                        GlobalStyles_1.globalStyles.marginTop25,
                    ], onPress: () => navigateTo('CaseHistoryOverview') },
                    react_1.default.createElement(atome_1.Text, { style: [Dashboard_web_style_1.styles.buttonText] }, "Details"))))) : (react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(react_native_1.TouchableOpacity, { style: [Dashboard_web_style_1.styles.button, Dashboard_web_style_1.styles.buttonInfo], onPress: () => navigateTo('CaseHistoryOverview') },
                react_1.default.createElement(atome_1.Text, { style: [Dashboard_web_style_1.styles.buttonText] }, "Details")))) }));
};
exports.UserInformationStep = UserInformationStep;
